import React from 'react';
import { twMerge } from 'tailwind-merge';
import { DefaultContent, Page } from '../components/imports';
import { motion } from 'framer-motion';
import useCardModal from '../hooks/useCardModal';

const Stories = () => {
  const storiesData = Array.from({ length: 20 }); // Adjust number of cards as needed
  const { activeIndex, /* rangeFinder, */ setActive } = useCardModal();

  const length = storiesData.length;

  // Calculate the 3 items left and right of activeIndex (if available)
  const lowerIndex = Math.max(activeIndex - 3, 0); // Ensuring not going below index 0
  const higherIndex = Math.min(activeIndex + 3, length - 1); // Ensuring not exceeding the last index
  const rangeOfIds = storiesData.slice(lowerIndex, higherIndex + 1); // Get the 3 items to the left and right including the active one

  /*   useEffect(() => {
      // Debugging: Monitor active card index and surrounding range
      console.log(activeIndex);
      console.log(lowerIndex, higherIndex);
    }, [activeIndex]); */

  return (
    <Page>
      <div className='full flex center relative min-h-[85vh] gap-1 bg-gradient-to-b from-slate-700'>
        <motion.div
          style={{
            transformStyle: "preserve-3d", // Preserve 3D transformations
            transform: "rotate3d(0, 5, 0, 25deg)",
            display: "flex",
            paddingLeft: "10vw", // Optional: Adjust for starting space
          }}
          className={twMerge("flex items-center justify-start")}
        >
          {storiesData.map((_, i) => (
            <StoryItem
              key={i}
              index={i}
              activeIndex={activeIndex}
              rangeOfIds={rangeOfIds}
              setActive={setActive}
              length={length}
            />
          ))}
        </motion.div>
      </div>
    </Page>
  );
};

const StoryItem = ({ activeIndex, rangeOfIds, setActive, index, length, className, ...props }) => {
  const isActive = activeIndex === index;
  const distanceFromCenter = Math.abs(activeIndex - index); // Find how far the card is from the center

  const gap = 5; // Adjust gap size
  const scale = isActive ? 1.2 : 1; // Active card scale
  const translateX = distanceFromCenter * (gap * (distanceFromCenter < 3 ? 1 : 2)); // Adjust movement
  const zIndex = isActive ? 10 : 1; // Keep the active card on top

  const isInRange = rangeOfIds.includes(index); // Check if the current index is within the range

  return (
    <motion.article
      style={{
        transformStyle: "preserve-3d",
        transform: `translateX(${translateX}px)`,
        scale,
        zIndex,
      }}
      transition={{
        ease: "easeOut",
        duration: 1, // Set duration for the effect
        delay: index * 0.1, // Stagger the effect for each card
      }}
      onClick={() => setActive(index)}
      className={twMerge(
        'flex relative aspect-square size-[150px] rounded-lg quick',
        isActive && "!scale-125 -translate-y-8",
        isInRange && "scale-105", // Apply special styles to the cards within range
        className
      )}
    >
      <DefaultContent className={`muted dim quick ${isActive && "nodim unmute"}`} />
      <span className='flex center bg-dark rounded-lg size-8 absolute p-3 -bottom-8 inset-x-0 w-fit mx-auto'>{index}</span>
    </motion.article>
  );
};

export default Stories;
